import './driverCards.css';
import user from '../../assets/images/user-2.png'

const DriverCards = ({driverType}) => {

    const driverClass = driverType === 'worst' ? 'red-box' : '';

    return(
        <ul className={'driver-cards'}>
            {
                [1, 2, 3, 4].map((driver) =>
                    <li key={driver} className={'flex gap-20'}>
                        <div className="user-img icon">
                            <img src={user} alt=""/>
                        </div>
                        <div className="sf-medium">
                            <div className={`rating-box margin-b-5 ${driverClass}`}>79</div>
                            <div className="margin-b-5">Ramesh Jagannath</div>
                            <div className="">ID: <span className={'sf-regular'}>6885</span></div>
                        </div>
                    </li>
                )
            }

        </ul>
    )

}

export default DriverCards;
